import 'arrayq';
import { PureConnect, React } from '../react';
import { Modal } from '../note/modal/index';
import Input from 'react-toolbox/lib/input';
import { questionaddresseeEditor } from './resource';
import cx from './style.less';
import UPDATE_BUTTON_NO from '../focuslock/actions/UPDATE_BUTTON_NO';
import FocusLockFocusGuard from '../focuslock/focuslockext';
import windowSelectors from '../window/selectors';
import { IQuestionAddressee } from '../types';
import { Btn } from '../react-toolbox-redesign/button';
const maxNameLength = 200;

export default PureConnect(`QuestionAddresseeEditModal`)(
    (state) => ({
        creating: questionaddresseeEditor.selectors.creating(state),
        item: questionaddresseeEditor.selectors.item(state),
        updating: questionaddresseeEditor.selectors.updating(state),      
        origin: state.notemenu.origin,   
        screenSmall: windowSelectors.small(state),   
    }),
    (dispatch) => ({ 
        cancel: () => dispatch(questionaddresseeEditor.actions.RESET({ })),
        cancelCreating: () => {            
            dispatch(questionaddresseeEditor.actions.CREATE_CANCEL({ }));},
        cancelUpdating: () => {
            dispatch(questionaddresseeEditor.actions.UPDATE_CANCEL({ }));},
        change: (item: IQuestionAddressee | any) => { dispatch(questionaddresseeEditor.actions.APPLY({ item }));},
    }),
    ({ creating, updating, item, origin, screenSmall, change, cancelCreating, cancelUpdating }) => {

        return (
            <Modal 
                onEscKeyDown={(creating ? ()=> cancelCreating() : ()=> cancelUpdating())} 
                    visible={(creating || updating)} 
                    type={screenSmall ? 'smallscreen': 'center2nd' }
                    backdrop={true}
                    header={<div className={cx('questionaddressee-title')}>{ (updating ? 'Standaard emailadres voor vragen bewerken' : 'Standaard emailadres voor vragen toevoegen')}</div>}
                >                   
                <div className={cx((!creating && !updating) ? 'wcag-invisible' : '', 'fields-container')}  
                    aria-hidden={!(creating || updating)} 
                    aria-labelledby= "Maak standaard emailadres aan voor de vragen">
                    <FocusLockFocusGuard 
                        disabled={!(creating || updating)}>   
                        <div className={cx('questionaddressee-container')}>
                            <div className={cx('input-naam')}>
                                <span className={cx('input-label')}>Naam<span className={cx('star')}>*</span></span>
                                    <Input  
                                    className={cx('questionaddressee-input')}
                                    type="text"
                                    name="name"
                                    value={item.name}
                                    maxLength={maxNameLength}
                                    multiline
                                    onChange={(value: string) => change({ name: value })}
                                    floating />                        
                            </div>                            
                            <div className={cx('input-naam-emailadres')}>
                                <span className={cx('input-label')}>Email<span className={cx('star')}>*</span></span>
                                    <Input  
                                    className={cx('questionaddressee-input')}
                                    type="text"
                                    name="email"
                                    value={item.email}
                                    maxLength={maxNameLength}
                                    multiline
                                    onChange={(value: string) => change({ email: value })}
                                    floating />                        
                            </div>        
                        
                        </div>
                                             
                        <QuestionAddresseeEditModalButtons></QuestionAddresseeEditModalButtons>
                    </FocusLockFocusGuard>
                </div>         
            </Modal> 
        );
    });

export const QuestionAddresseeEditModalButtons = PureConnect(`QuestionAddresseeEditModalButtons`)(
    (state) => ({                  
        creating: questionaddresseeEditor.selectors.creating(state),
        item: questionaddresseeEditor.selectors.item(state),
        updating: questionaddresseeEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        selectNote: state.selection.creating, 
        screenSmall: windowSelectors.small(state),   
    }),
    (dispatch) => ({
        cancel: () => dispatch(questionaddresseeEditor.actions.RESET({ })),
        cancelCreating: () => {            
            dispatch(questionaddresseeEditor.actions.CREATE_CANCEL({ }));},
        cancelUpdating: () => {
            dispatch(questionaddresseeEditor.actions.UPDATE_CANCEL({ }));},
        change: (item: IQuestionAddressee | any) => { dispatch(questionaddresseeEditor.actions.APPLY({ item }));},
        saveCreating: (item: IQuestionAddressee) => {             
            item = fixNoteDevelopmentJsonServer(item, true);
            dispatch(questionaddresseeEditor.actions.CREATE_CONTINUE({ item })); },
        saveUpdating: (item: IQuestionAddressee) => {            
            item = fixNoteDevelopmentJsonServer(item, false);
            dispatch(questionaddresseeEditor.actions.UPDATE_CONTINUE({ item })); },
        updateButtonFocus: (buttonNr: number, origin: number, itm: IQuestionAddressee) => {
            dispatch(UPDATE_BUTTON_NO({buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem:itm})); 
        },
    }),
    ({ creating, updating, item, saveCreating, cancelCreating, saveUpdating, cancelUpdating }) => {
        var visible = (creating || updating);     
        return (
            <div className={cx('bottom-panel', (!visible) ? 'wcag-invisible' : '')}
                aria-hidden={!(visible)}
                aria-labelledby="Maak een standaard emailadres aan voor de vragen">
                {/* WCAG (button):
                            1) no role; they are buttons
                            2) focussable (Tab)
                            3) toggle function: n/a (when true use aria-checked)
                            4) aria-expanded: n/a
                            5) aria-haspopup: n/a  
                            6) aria-labelledby/aria-describedby: ref to label
                            7) icon of button is explained by tekst-> aria-hidden*/}
                <div className={cx('bottom-buttons')}>
                    <div className={cx('buttons-container')}>
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Annuleren'}
                            aria-haspopup={false}
                            tabIndex={0}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt,
                                    creating ?
                                        () => { cancelCreating(); } :
                                        () => { cancelUpdating(); });
                            }}
                            onClick={creating ?
                                () => { cancelCreating(); } :
                                () => { cancelUpdating(); }}
                        >
                            <span>Annuleren</span>
                        </Btn>

                        <Btn
                            type="button"
                            className={'btn'}
                            aria-label={'Opslaan'}
                            aria-haspopup={false}
                            tabIndex={item.email && item.name ? 0 : -1}
                            disabled={!item.email || !item.name}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt, creating ?
                                    () => saveCreating(item) :
                                    () => saveUpdating(item));
                            }}
                            onClick={creating ?
                                () => saveCreating(item) :
                                () => saveUpdating(item)}
                        >
                            <span>Opslaan</span>
                        </Btn>
                    </div>

                </div>
            </div>

        );
});

function handleEnters(evt: any, funct: ()=>void) {
    if (evt.key==='Enter') {evt.preventDefault(); funct();}
}   

function fixNoteDevelopmentJsonServer(item: IQuestionAddressee, create: boolean) {

    return item;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/questionaddressee/editModal.tsx